'use strict';

var CommonFaresChartComponentsService = function CommonFaresChartComponentsService(momentService, userPreferencesService) {
  function getCurrentMonth() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).month();
  }
  function getInitialLegend() {
    var currentMonth = getCurrentMonth();
    var legend = [{
      label: 'Jan',
      color: '#ff8d2e',
      monthId: 0,
      css: 'fares-legend-item-jan',
      barCss: 'rm-chart-svg-rect-color-jan'
    }, {
      label: 'Feb',
      color: '#ffc694',
      monthId: 1,
      css: 'fares-legend-item-feb',
      barCss: 'rm-chart-svg-rect-color-feb'
    }, {
      label: 'Mar',
      color: '#206080',
      monthId: 2,
      css: 'fares-legend-item-mar',
      barCss: 'rm-chart-svg-rect-color-mar'
    }, {
      label: 'Apr',
      color: '#3399cc',
      monthId: 3,
      css: 'fares-legend-item-apr',
      barCss: 'rm-chart-svg-rect-color-apr'
    }, {
      label: 'May',
      color: '#a2d8f2',
      monthId: 4,
      css: 'fares-legend-item-may',
      barCss: 'rm-chart-svg-rect-color-may'
    }, {
      label: 'Jun',
      color: '#53335e',
      monthId: 5,
      css: 'fares-legend-item-jun',
      barCss: 'rm-chart-svg-rect-color-jun'
    }, {
      label: 'Jul',
      color: '#b27ec4',
      monthId: 6,
      css: 'fares-legend-item-jul',
      barCss: 'rm-chart-svg-rect-color-jul'
    }, {
      label: 'Aug',
      color: '#e4cfec',
      monthId: 7,
      css: 'fares-legend-item-aug',
      barCss: 'rm-chart-svg-rect-color-aug'
    }, {
      label: 'Sep',
      color: '#195e51',
      monthId: 8,
      css: 'fares-legend-item-sep',
      barCss: 'rm-chart-svg-rect-color-sep'
    }, {
      label: 'Oct',
      color: '#28927d',
      monthId: 9,
      css: 'fares-legend-item-oct',
      barCss: 'rm-chart-svg-rect-color-oct'
    }, {
      label: 'Nov',
      color: '#abded4',
      monthId: 10,
      css: 'fares-legend-item-nov',
      barCss: 'rm-chart-svg-rect-color-nov'
    }, {
      label: 'Dec',
      color: '#ff3300',
      monthId: 11,
      css: 'fares-legend-item-dec',
      barCss: 'rm-chart-svg-rect-color-dec'
    }];
    var numOfRange = parseInt(userPreferencesService.getUserSettingComponent('defaultSelectedMonths'));
    var range = [];
    for (var j = 1; j <= numOfRange; j++) {
      range.push((currentMonth + 12 - j) % 12);
    }
    for (var i = 0; i < 12; i++) {
      legend[i].selected = range.indexOf(i) !== -1;
    }
    return legend;
  }
  return {
    getCurrentMonth: getCurrentMonth,
    getInitialLegend: getInitialLegend
  };
};
CommonFaresChartComponentsService.$inject = ['MomentService', 'UserPreferencesService'];
module.exports = CommonFaresChartComponentsService;